import useToast from '@/components/Toast/useToast';
import { useSessionUpdateMutation } from '@/hooks/useSwr';

export const useUpdateSessionName = (
  sessionId?: string,
  onError?: () => void
) => {
  const { createToast } = useToast();
  const { trigger } = useSessionUpdateMutation(sessionId ?? '', {
    onError: (error) => {
      onError?.();
      createToast({
        title: 'Error updating session name',
        description: error.message,
      });
    },
  });

  return trigger;
};
